module.exports = __webpack_public_path__ + "static/media/avatar.0a22e927.png";